import { createAction, props } from '@ngrx/store';
import { EsmRevenueHeadReducerInitialState } from '../reducers/admin-esm-revenue-head.reducer';

const prefix = '[Admin-esm-revenue-head]';

export const setStateAction = createAction(
  `${prefix} set state`,
  props<Partial<EsmRevenueHeadReducerInitialState>>()
);

export const setQueryAction = createAction(
  `${prefix} set query`,
  props<
    Partial<{
      minDate: string;
      maxDate: string;
      esId: string;
    }>
  >()
);

export const resetQueryAction = createAction(
  `${prefix} reset query`,
  props<any>()
);
